// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const LargeLanguageModelIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon
      data-iconname="LargeLanguageModelIcon"
      ref={forwardedRef}
      {...props}
    >
      <path d="M9.495 5.001H3.5v8.5h3.25v2.415l4.16-2.415h5.59v-2.226H18v2.726a1 1 0 0 1-1 1h-5.868L5.25 18.416v-3.415H3l-.103-.005a1 1 0 0 1-.892-.893L2 14.002v-9.5a1 1 0 0 1 .897-.995L3 3.5h6.495z" />
      <path d="M15.155 3.219a3 3 0 0 0 2.216 2.37L19 6l-1.629.411a3 3 0 0 0-2.216 2.37L14.75 11l-.405-2.219a3 3 0 0 0-2.216-2.37L10.5 6l1.629-.411a3 3 0 0 0 2.216-2.37L14.75 1z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const LargeLanguageModelIcon = /* @__PURE__ */ Object.assign(
  LargeLanguageModelIconComponent,
  { displayName: 'LargeLanguageModelIcon' },
);
